// extracted by mini-css-extract-plugin
module.exports = {"grid":"FeatureGrid_grid__uSjTv","gridSingle":"FeatureGrid_gridSingle__D_m4_"};